module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/library-assets/article-list/article-list.component.scss
// module id = ./src/app/library-assets/article-list/article-list.component.scss
// module chunks = main